import React from "react";
import { Container } from "../layout/Container";
import Button from "../components/Button";
import styled from "styled-components";
import useTranslation from "../hooks/useTranslation";
import bg from "../img/illustrations/background.png";
import obs from "../img/Static/obs.png";
import streamLabs from "../img/Static/streamlabs.png";
import obsLive from "../img/Static/obs-live.png";
import preview from "../img/Static/preview.png";
import controls from "../img/Static/controls.png";
import settings from "../img/Static/settings.png";
import sound from "../img/Static/sound.png";
import video from "../img/Static/video.png";

let paragraphs = [
  [
    "Free and open source software for recording and live streaming. Source code is available to everyone to contribute and improve.",
  ],
  [
    "Streamlabs OBS is a free, open-source, all-in-one streaming software for new streamers and power users alike. Everything you need to live stream is available in one solution: built-in widgets & chat, game-optimized settings, selective recording, 50 unique apps, and thousands of overlays and themes.",
  ],
  [
    "OBS.Live is StreamElements' OBS Studio free add-on for streaming (supports V23). OBS.Live makes stream management easy, integrating Twitch chat, your Activity Feed, and Media Request directly into OBS. Other features include Custom Bot name, HotKeys and Leaderboards.",
  ],
];

let titles = [
  ["Open Brodcaster Software OBS"],
  ["Streamlabs OBS"],
  ["OBS.Live"],
];

let URLs = [
  ["https://obsproject.com/", "https://obsproject.com/help"],
  [
    "https://streamlabs.com/streamlabs-obs-live-streaming-software",
    "https://streamlabs.com/content-hub/post/getting-started-with-streamlabs-obs",
  ],
  [
    "https://streamelements.com/obslive",
    "https://blog.streamelements.com/obs-live-adds-media-requests-to-livens-up-your-stream-increase-viewer-engagement-and-revenue-1e8f88887374",
  ],
];

const Appcard = (props) => {
  const { t } = useTranslation();
  return (
    <MiniCard>
      <img src={props.img} alt="OBS" />
      <h6>{props.title}</h6>
      <p>{props.paragraph}</p>
      <Buttons>
        <Btn href={props.guide} variant={"secondary"} outline={"true"}>
          {t('howtostream.guide')}
        </Btn>
        <Btn href={props.download} variant={"primary"}>
          {t('howtostream.download')}
        </Btn>
      </Buttons>
    </MiniCard>
  );
};

const HowToStream = () => {
  const { t } = useTranslation();
  return (
    <Page>
      <Con>
        <H1>{t('howtostream.how_to_stream')}</H1>
        <H3>{t('howtostream.download_broadcaster')}</H3>
        <H6>{t('howtostream.broadcasting_apps')}</H6>
        <P>{t('howtostream.common_tools')}</P>
        <Box>
          <AppCard
            img={obs}
            title={titles[0]}
            paragraph={paragraphs[0]}
            guide={URLs[0][1]}
            download={URLs[0][0]}
          />
          <AppCard
            img={streamLabs}
            title={titles[1]}
            paragraph={paragraphs[1]}
            guide={URLs[1][1]}
            download={URLs[1][0]}
          />
          <AppCard
            img={obsLive}
            title={titles[2]}
            paragraph={paragraphs[2]}
            guide={URLs[2][1]}
            download={URLs[2][0]}
          />
        </Box>
        <H6>{t('howtostream.obs_title')}</H6>
        <P>{t('howtostream.obs_description')}</P>
        <H3>{t('howtostream.setup_broadcaster')}</H3>
        <H6>{t('howtostream.obs_dashboard')}</H6>
        <Img src={preview} alt="OBS dashboard" />
        <H6>{t('howtostream.setup_source')}</H6>
        <Img src={controls} alt="controls section" />
        <P>
          {t('howtostream.controls_instructions')}
        </P>
        <Img src={settings} alt="settings pannel" />
        <P>
          {t('howtostream.server_url_instructions')}
        </P>
        <H3>{t('howtostream.start_streaming')}</H3>
        <H6>{t('howtostream.preview_setup')}</H6>
        <P>
          {t('howtostream.preview_instructions')}
        </P>
        <Img src={sound} alt="voice timeline" />
        <Img src={video} alt="video scenes" />
        <H6>{t('howtostream.go_live')}</H6>
        <P>
          {t('howtostream.go_live_instructions')}
        </P>
        <Img src={controls} alt="controls section" />
      </Con>
    </Page>
  );
};

export default HowToStream;
export const Page = styled.div`
  padding-top: 4rem;
  /* height: 100%; */
  background-image: url(${bg});
  background-size: cover;
  background-attachment: fixed;
`;

export const Img = styled.img`
  display: block;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;
  box-shadow: 0px 0px 40px 16px rgba(0, 0, 0, 0.21);
  border-radius: 10px;
`;

export const Box = styled.div`
  display: flex;
  margin: auto;
`;

export const MiniCard = styled.div`
  padding-top: 2rem;
  margin: 2rem;
  width: 400px;
  min-height: 520px;
  text-align: center;
  border-radius: 5px;
  position: relative;
  img {
    margin: 1rem;
    width: 105px;
    height: 105px;
  }
  h6 {
    margin: auto;
    max-width: 200px;
    font-size: 22px;
    color: ${({ theme }) => theme.color.primary};
  }
  p {
    margin: auto;
    padding-top: 1rem;
    padding-bottom: 3rem;
    font-family: "Poppins";
    max-width: 80%;
    text-align: left;
    font-size: 14px;
  }
  background-color: ${({ theme }) => theme.color.secondaryBg};
`;

const Buttons = styled.div`
  display: flex;
  width: 80%;
  justify-content: space-between;
  position: absolute;
  margin-top: 30px;
  margin-bottom: 10px;
  bottom: 30px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`;

const Btn = styled(Button)`
  width: 47%;
`;

const Con = styled(Container)`
  height: 100%;
  width: 70%;
  margin: auto;
  padding-bottom: 30px;
  background-color: ${({ theme }) => theme.color.background};
`;

const AppCard = styled(Appcard)`
  height: px;
  width: 100px;
  margin: auto;
  align-items: center;
  text-align: center;
  background-color: ${({ theme }) => theme.color.secondaryBg};
`;

export const H1 = styled.h1`
  margin-left: 2rem;
  padding-top: 4rem;
  font-size: 700;
  color: ${({ theme }) => theme.color.primary};
`;

export const H3 = styled.h3`
  margin-left: 3rem;
  margin-top: 2rem;
  color: ${({ theme }) => theme.color.darkerText};
`;

export const H6 = styled.h6`
  margin-left: 3rem;
  margin-top: 2rem;
  color: ${({ theme }) => theme.color.darkerText};
`;

export const P = styled.p`
  margin: auto;
  max-width: 90%;
  margin-top: 1rem;
  color: ${({ theme }) => theme.color.darkerText};
`;
